function fetchConfig() {
    return {
        // method: "GET",
        headers: {
            token: window.GLOBAL.sbdApiAccessToken,
        },
    };
}

async function fetchAPI(path, config) {
    const url = new URL(window.GLOBAL.sbdApiUrl);
    url.pathname = path;

    const response = await fetch(url, config);

    if (!response.ok) {
        throw response;
    }

    return response.json();
}

async function addToWishlist(payload) {
    const config = fetchConfig();
    config.method = "POST";
    config.headers = { 
        token: window.GLOBAL.sbdApiAccessToken,
        "Content-Type": "application/json"
    };
    config.body = JSON.stringify(payload);



    return await fetchAPI("/api/addWishListItem", config);
}

async function getWishlist() {
    const config = fetchConfig();
    config.method = "GET";
    config.headers = { 
        token: window.GLOBAL.sbdApiAccessToken
    };
    return await fetchAPI(`/api/getWishListItems/${window.GLOBAL.customerId}`, config);
}

async function removeFromWishlist(payload) {
    const config = fetchConfig();
    config.method = "POST";
    config.headers = { 
        token: window.GLOBAL.sbdApiAccessToken,
        "Content-Type": "application/json"
    };
    config.body = JSON.stringify(payload);

    return await fetchAPI("/api/removeWishListItem", config);
}

(async () => {
    if (window.GLOBAL.customerId) {
        window.GLOBAL.wishlist = await getWishlist();
        const event = new window.CustomEvent('wishlistLoaded', { detail: window.GLOBAL.wishlist })
        setTimeout(() => {
            window.document.dispatchEvent(event)
        }, 500)
    }
})();
